import React, { useState, useEffect } from 'react';

export default function Hangman(props, { duration = 120000 }) {
    

        // Close button wasn't working because props needs to be declared first in function parameters.
        // https://hackernoon.com/tutorial-building-a-hangman-game-with-react-hooks-c22c354a?hmsr=joyk.com&utm_source=joyk.com&utm_medium=referral
        const word = "HANGMAN";
        const alphabets = ["A", "B", "C", "D", "E", "F", "G",
            "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R",
            "S", "T", "U", "V", "W", "X", "Y", "Z"];
        const [correctGuesses, setCorrectGuesses] = useState([]);
        const [timeUp, setTimeUp] = useState(false);

        useEffect(() => {
            const timeout = setTimeout(() => {
                setTimeUp(true);
            }, duration)

            return () => clearTimeout(timeout);
        }, []);

        const maskedWord = word.split('').map(letter =>
            correctGuesses.includes(letter) ? letter : "_").join("");

        return (
            <React.Fragment>
                <div className="Modal">
                    <div className="ModalBg">
                        <div className="ModalContent Hangman">

                            <h2>Hangman</h2>
                            <p>{maskedWord}</p>
                            {alphabets
                                .map((alphabet, index) =>

                                    <button key={index} onClick={() => {
                                        if (word.includes(alphabet)) {
                                            setCorrectGuesses([...correctGuesses, alphabet])
                                        }
                                    }}>{alphabet}</button>)

                            }
                            {!maskedWord.includes("_") && <p>You won!</p>}

                            <hr />
                            <button onClick={() => props.onClose()}>Close</button>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        )
    
}